<template>
  <div>
    <b-button @click="buildForm" id="help-button" v-b-modal.help-modal><i class="fa fa-comment" aria-hidden="true"></i></b-button>
    <b-modal id="help-modal" title="Help Request Form" size="lg" hide-footer>
      <b-alert v-model="showDismissibleAlert" variant="success" dismissible>
        Your Message Has Been Sent!
      </b-alert>
      <p class="">Have a question about your dashboard or experiencing a problem with Momentum? Please let us know or ask here.</p>
      {{ dashboard.name }}
      <b-form @submit="onSubmit" @reset="buildForm">
        <div class="row">
          <b-form-group
            class="col-sm-12"
            id="input-email"
            label="Email address:"
            label-for="email"
            >
            <b-form-input
              id="email"
              v-model="help_request.email"
              type="email"
              required
              placeholder="Enter Email"
              ></b-form-input>
          </b-form-group>
            <b-form-group class="col-sm-6" id="input-first-name" label="First Name:" label-for="first-name">
              <b-form-input
                id="first-name"
                v-model="help_request.first_name"
                required
                placeholder="Enter Name"
                ></b-form-input>
            </b-form-group>

            <b-form-group class="col-sm-6" id="input-last-name" label="Last Name:" label-for="last-name">
              <b-form-input
                id="last-name"
                v-model="help_request.last_name"
                required
                placeholder="Enter Name"
                ></b-form-input>
            </b-form-group>

            <b-form-group class="col-sm-6" id="input-client-name" label="Client Name:" label-for="client-name">
              <b-form-input
                id="client-name"
                v-model="help_request.client"
                placeholder="Enter Client Name"
                ></b-form-input>
            </b-form-group>

            <b-form-group class="col-sm-6" id="input-dashboard-name" label="Dashboard Name:" label-for="dashboard-name">
              <b-form-input
                id="dashboard-name"
                v-model="help_request.dashboard"
                placeholder="Enter Dashboard Name"
                ></b-form-input>
            </b-form-group>
            <b-form-group class="col-sm-12" id="input-url" label="URL:" label-for="url">
              <b-form-input
                id="url"
                v-model="help_request.current_url"
                placeholder="Enter URL"
                ></b-form-input>
            </b-form-group>
            <div class="col-sm-6">
              <div class="col-form-label pt-0">Start - End Date</div>
              <date-range-picker :startDate="help_request.start_date" :endDate="help_request.end_date"/>
            </div>
            <div class="col-sm-6" v-if="compareStartDate">
              <div class="col-form-label pt-0">Compare Start - End Date</div>
              <date-range-picker :startDate="help_request.compare_start_date" :endDate="help_request.compare_end_date"/>
            </div>
            <b-form-group class="col-sm-12" id="input-subject" label="Subject:" label-for="subject">
              <b-form-input
                id="subject"
                v-model="help_request.subject"
                placeholder="Enter Subject"
                required
                ></b-form-input>
            </b-form-group>
            <b-form-group class="col-sm-12" label="Upload screenshot:">
              <vue2-dropzone :options="dropOptions" id='uploader' v-on:vdropzone-success='fileAdded' v-on:vdropzone-removed-file='removeFile'></vue2-dropzone>
            </b-form-group>
            <div class="col-sm-12 mt-2">
              <label for="content">Message:</label>
              <b-form-textarea
                v-model="help_request.content"
                id="content"
                size="lg"
                placeholder=""
                rows="4"
                required
                ></b-form-textarea>
            </div>
        </div>
        <div class="mt-3">
          <b-button type="submit" variant="primary">Submit</b-button>
          <b-button class="ml-2" type="reset" variant="danger">Reset</b-button>
        </div>
      </b-form>
    </b-modal>
  </div>
</template>

<script>
import { mapGetters } from 'vuex'
import DateRangePicker from 'vue2-daterange-picker'
import vue2Dropzone from 'vue2-dropzone'
import 'vue2-dropzone/dist/vue2Dropzone.min.css'

export default {
  components: {
    DateRangePicker,
    vue2Dropzone
  },
  data: function () {
    return {
      files: {},
      dropOptions: {
        url: process.env.NODE_ENV == 'development' ? 'http://localhost:3000/uploads' : 'https://momentumapi.gosokal.com/uploads',
        headers: { 'Authorization': 'Bearer ' + localStorage.token },
        addRemoveLinks: true,
        dictRemoveFileConfirmation:  'Are you sure?',
      },
      help_request: {
        first_name: '',
        last_name: '',
        email: '',
        client: null,
        dashboard: null,
        start_date: null,
        end_date: null,
        compare_start_date: null,
        compare_end_date: null,
        subject: '',
        content: '',
        current_url: ''
      },
      showDismissibleAlert: false
    }
  },

  computed: {
    ...mapGetters([
      'startDate',
      'endDate',
      'compareStartDate',
      'compareEndDate',
      'currentUser',
      'dashboard',
      'currentClient'
    ])
  },

  created() {
    this.buildForm()
  },

  mounted () {
    this.positionModal()
    window.addEventListener('scroll', this.positionModal)
  },

  watch: {
    $route () {
      this.positionModal()
    }
  },

  methods: {
    fileAdded (file, response) {
      this.files[file.name] = response['id']
    },
    removeFile (file) {
      var fileId = this.files[file.name]
      this.$http.delete('/uploads/'+fileId)
        .then(() => {
          delete this.files[file.name]
        }).catch((e) => { console.log(e) })
    },
    buildForm () {
      this.help_request.first_name = this.currentUser.firstName || ''
      this.help_request.last_name = this.currentUser.lastName || ''
      this.help_request.email = this.currentUser.email || ''
      this.help_request.client = (this.currentClient && this.currentClient.name) ? this.currentClient.name : ''
      this.help_request.dashboard = (this.dashboard && this.dashboard.name) ? this.dashboard.name : ''
      this.help_request.current_url = `https://momentum.gosokal.com${this.$route.fullPath}` || ''
      this.help_request.start_date = this.startDate || ''
      this.help_request.end_date = this.endDate || ''
      this.help_request.compare_start_date = this.compareStartDate || ''
      this.help_request.compare_end_date = this.compareEndDate || ''
      this.help_request.subject = ''
      this.help_request.content = ''
      this.showDismissibleAlert = false
    },
    onSubmit (e) {
      e.preventDefault()
      this.help_request.attachments = Object.values(this.files).map(function(id){
        var hash = {}
        hash.id = id
        return hash
      })
      this.$http.post('/help_requests', this.help_request)
        .then(() => {
          this.submitSuccessful()
        })
        .catch((e) => {
          console.log(e)
        })
    },
    submitSuccessful () {
      this.buildForm()
      this.showDismissibleAlert = true
    },
    positionModal () {
      if ((document.documentElement.scrollHeight - (window.scrollY + window.innerHeight)) < 50) {
        document.getElementById('help-button').style.bottom = "62px"
      } else {
        document.getElementById('help-button').style.bottom = "12px"
      }
    }
  }
}
</script>

<style>
</style>

<style scoped>
#help-button {
  border: 0;
  border-radius: 50px;
  bottom: 62px;
  right: 12px;
  position: fixed;
  background-color: #0a4e91;
  width: 54px;
  height: 54px;
  z-index: 1000;
  -webkit-transition: all 0.3s ease;
  -moz-transition: all 0.3s ease;
  -o-transition: all 0.3s ease;
  transition: all .3s ease;
}
#help-button .fa-comment {
  color: #fff;
  font-size: 25px;
}
</style>
